import { resolvePageSection } from '~/composables/usePageSection'
import { useCartOriginSection } from '~/composables/useCartOriginSection'

/**
 * UI Tracking: Cart Origin Section
 * This plugin is responsible for capturing the page the user navigated from right before entering the cart page.
 * The `view_cart` tracker reports the section the user decided to proceed to cart from, instead of a hardcoded `'cart'`.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { setOriginSection } = useCartOriginSection()

  router.beforeEach((to, from) => {
    if (resolvePageSection(to.path) !== 'cart')
      return

    // Ignore the initial app load / direct navigation (no real previous route),
    // so direct cart visits fall back to the current route section instead.
    if (!from.matched.length)
      return

    setOriginSection(resolvePageSection(from.path))
  })
})
